export default __webpack_public_path__ + "static/media/Emojis05.ba97d21b.png";